module.exports = __webpack_public_path__ + "img/chengying.77c9afc5.png";